"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetIdToPoolAssetId = exports.poolAssetIdToAssetId = exports.thorPoolIdAssetIdSymbolMap = void 0;
const invert_1 = __importDefault(require("lodash/invert"));
const generatedTradableThorAssetMap_json_1 = __importDefault(require("../../generated/generatedTradableThorAssetMap.json"));
exports.thorPoolIdAssetIdSymbolMap = generatedTradableThorAssetMap_json_1.default;
const assetIdToPoolAssetIdMap = (0, invert_1.default)(exports.thorPoolIdAssetIdSymbolMap);
const poolAssetIdToAssetId = (id) => exports.thorPoolIdAssetIdSymbolMap[id.toUpperCase()];
exports.poolAssetIdToAssetId = poolAssetIdToAssetId;
const assetIdToPoolAssetId = ({ assetId }) => assetIdToPoolAssetIdMap[assetId.toLowerCase()];
exports.assetIdToPoolAssetId = assetIdToPoolAssetId;
